import type { ReactNode, CSSProperties } from 'react'

export default function AutoGrid({
  children,
  style,
  className,
}: {
  children: ReactNode
  style?: CSSProperties
  className?: string
}) {
  return (
    <div
      className={className ?? 'telemetry-kpi-grid'}
      style={{ gridTemplateColumns: 'repeat(5, minmax(0, 1fr))', ...style }}
    >
      {children}
    </div>
  )
}
